!function() {
  "use strict";
  
  console.log("BASE.JS LOADED - TEST MESSAGE - TIMESTAMP: " + new Date().toISOString());
  
  !function() {
    var t = {};
    function e(t) {
      return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
    function n(n) {
      var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n,
          i = e(n),
          u = i[0],
          a = i[i.length - 1];
      r(),
      t.focusin = function(e) {
        e.target !== n && e.target !== a && e.target !== u || document.addEventListener("keydown", t.keydown)
      },
      t.focusout = function() {
        document.removeEventListener("keydown", t.keydown)
      },
      t.keydown = function(t) {
        "TAB" === t.code.toUpperCase() && (t.target !== a || t.shiftKey || (t.preventDefault(), u.focus()), t.target !== n && t.target !== u || !t.shiftKey || (t.preventDefault(), a.focus()))
      },
      document.addEventListener("focusout", t.focusout),
      document.addEventListener("focusin", t.focusin),
      o.focus()
    }
  }();
}();

// Fix for menu toggle functionality
document.addEventListener("DOMContentLoaded", function() {
  const menuDetails = document.getElementById('Details-menu-drawer-container');
  const menuSummary = menuDetails?.querySelector('summary');
  const menuDrawer = document.getElementById('menu-drawer');

  if (menuDetails && menuSummary && menuDrawer) {
    // Add custom CSS to fix menu drawer visibility
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      .menu-drawer {
        position: fixed !important;
        top: 0 !important;
        height: 100vh !important;
        transform: translateY(0) !important;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0.3s, opacity 0.3s !important;
      }
      
      details[open] > .menu-drawer {
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      .menu-drawer__navigation-container {
        padding-top: 80px;
        position: relative;
      }
      
      .menu-drawer__close-button {
        position: absolute;
        top: 20px;
        background: transparent;
        border: none;
        padding: 0;
        cursor: pointer;
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        z-index: 5;
      }
      
      .menu-drawer__close-icon {
        width: 35px;
        height: 35px;
        color: white;
        stroke: white;
      }
    `;
    document.head.appendChild(styleSheet);
    
    // Create close button
    const closeButton = document.createElement('button');
    closeButton.className = 'menu-drawer__close-button';
    closeButton.setAttribute('aria-label', 'Close menu');
    closeButton.innerHTML = `
      <svg class="menu-drawer__close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    
    // Add close button to menu drawer
    const navigationContainer = menuDrawer.querySelector('.menu-drawer__navigation-container');
    if (navigationContainer) {
      navigationContainer.insertBefore(closeButton, navigationContainer.firstChild);
    } else {
      menuDrawer.insertBefore(closeButton, menuDrawer.firstChild);
    }
    
    // Add click event to close button
    closeButton.addEventListener('click', function() {
      menuDetails.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    });
    
    // Toggle menu on summary click
    menuSummary.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (menuDetails.hasAttribute('open')) {
        menuDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      } else {
        menuDetails.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }
    });
    
    // Close menu when clicking a navigation link
    const navLinks = document.querySelectorAll('.menu-drawer__navigation a');
    navLinks.forEach(link => {
      link.addEventListener('click', function() {
        menuDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      });
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (menuDetails.hasAttribute('open') && 
          !menuDrawer.contains(e.target) && 
          !menuSummary.contains(e.target)) {
        menuDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    });
    
    // Close menu with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menuDetails.hasAttribute('open')) {
        menuDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }
});

// Cart page minimum quantity check
document.addEventListener("DOMContentLoaded", function () {
    console.log("Checking for minimum quantity modal display...");
    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) {
        console.log("Cart form not found");
        return;
    }

    // Change to the specific product ID we want to check
    const targetProductId = "8791615701207"; 
    let targetProductQuantity = 0;
    let targetProductFound = false;
    const cartRows = document.querySelectorAll(".cart-item");
    
    console.log("Number of cart items found:", cartRows.length);

    // First try to find the product by checking data attributes or hidden fields
    const cartItemsContainer = document.getElementById("main-cart-items");
    if (cartItemsContainer) {
        // Try to get cart data from the page
        const cartItems = Array.from(cartRows);
        console.log("Checking cart items...");
        
        cartItems.forEach(function(row, index) {
            // Look for product ID in various places
            const productLink = row.querySelector("a.cart-item__name");
            const quantityInput = row.querySelector(".quantity__input");
            const productTitle = row.querySelector(".cart-item__name")?.textContent?.trim();
            
            console.log(`Item ${index + 1}:`, {
                title: productTitle,
                url: productLink?.href,
                quantity: quantityInput ? parseInt(quantityInput.value) : 0
            });
            
            // Check if this is our target product - try multiple detection methods
            const isTargetProduct = 
                (productLink && productLink.href && productLink.href.includes(targetProductId)) || 
                (productLink && productLink.href && productLink.href.includes("cylinder-swap")) ||
                (productTitle && productTitle.toLowerCase().includes("cylinder swap"));
                
            if (isTargetProduct) {
                console.log("Target product found!");
                targetProductFound = true;
                const quantity = quantityInput ? parseInt(quantityInput.value) : 0;
                targetProductQuantity += quantity;
                console.log("Quantity:", quantity);

                // Set minimum quantity on the input
                if (quantityInput) {
                    quantityInput.setAttribute('min', '2');
                }
            }
        });
    }

    console.log("Target product found:", targetProductFound);
    console.log("Target product quantity:", targetProductQuantity);

    // Only show modal if the specific product is found and quantity is exactly 1
    if (targetProductFound && targetProductQuantity === 1) {
        console.log("Showing modal...");
        const modal = document.getElementById("minimumQuantityModal");
        const modalMessage = document.getElementById("modalMessage");

        if (!modal) {
            console.warn("Modal element not found");
            return;
        }

        if (modalMessage) {
            modalMessage.innerHTML = `We are moving to a minimum order of 'x2 swaps' soon - 
                <a href="/collections/all" style="color: #242060; text-decoration: underline;">buy extra cylinders</a> 
                or visit our 
                <a href="/pages/cylinder-pickup" style="color: #242060; text-decoration: underline;">cylinder pick up</a> 
                page here if you wish to swap back to your original brand!`;
        }

        modal.style.display = "flex";
        
        const modalDismiss = document.getElementById("modalDismiss");
        if (modalDismiss) {
            modalDismiss.addEventListener("click", function () {
                modal.style.display = "none";
            });
        }

        const modalAddBurpi = document.getElementById("modalAddBurpi");
        if (modalAddBurpi) {
            modalAddBurpi.addEventListener("click", function () {
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: "45945298550999", // Variant ID from the cart item
                        quantity: 1
                    })
                })
                .then(response => response.json())
                .then(() => window.location.reload())
                .catch(error => console.error("Error adding product:", error));
            });
        }
    }
});

function initAutocomplete() {
  const waitForInputField = setInterval(() => {
    // Find the input by its data-label attribute
    const inputField = document.querySelector('input[data-label="Pickup address"]');
    if (inputField) {
      clearInterval(waitForInputField); // Stop checking once the input field is found

      // Initialize Google Places Autocomplete with restrictions to Australia
      const autocomplete = new google.maps.places.Autocomplete(
        inputField,
        {
          types: ['address'], // Restrict results to addresses
          componentRestrictions: { country: 'AU' } // Limit results to Australia
        }
      );

      // Listener for when the user selects an address
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        console.log('Selected Address:', place.formatted_address);

        // Example: Extract specific address components
        const addressComponents = {};
        place.address_components.forEach((component) => {
          if (component.types.includes('route')) {
            addressComponents.street = component.long_name;
          }
          if (component.types.includes('street_number')) {
            addressComponents.streetNumber = component.long_name;
          }
          if (component.types.includes('locality')) {
            addressComponents.suburb = component.long_name;
          }
          if (component.types.includes('administrative_area_level_1')) {
            addressComponents.state = component.short_name;
          }
          if (component.types.includes('postal_code')) {
            addressComponents.postcode = component.long_name;
          }
        });

        console.log('Address Components:', addressComponents);

        // Update hidden fields with extracted address components
        const streetField = document.querySelector('input[name="checkout[shipping_address][address1]"]');
        const suburbField = document.querySelector('input[name="checkout[shipping_address][city]"]');
        const stateField = document.querySelector('select[name="checkout[shipping_address][province]"]');
        const postcodeField = document.querySelector('input[name="checkout[shipping_address][zip]"]');

        if (streetField && addressComponents.streetNumber && addressComponents.street) {
          streetField.value = `${addressComponents.streetNumber} ${addressComponents.street}`;
        }

        if (suburbField && addressComponents.suburb) {
          suburbField.value = addressComponents.suburb;
        }

        if (stateField && addressComponents.state) {
          stateField.value = addressComponents.state;
        }

        if (postcodeField && addressComponents.postcode) {
          postcodeField.value = addressComponents.postcode;
        }
      });
    }
  }, 500);
}

// Variant price update
document.addEventListener("DOMContentLoaded", function() {
    const variantRadios = document.querySelectorAll('input[type="radio"][name^="options["]');
    const priceElement = document.querySelector('.price__regular .price-item');

    if (!variantRadios.length || !priceElement) {
        console.error("Variant radios or price element not found.");
        return;
    }

    variantRadios.forEach((radio) => {
        radio.addEventListener("change", function () {
            const price = this.getAttribute("data-price");

            if (price) {
                priceElement.textContent = `$${(price / 100).toFixed(2)}`;
            }
        });
    });
});

// Click-in modal functionality
document.addEventListener("DOMContentLoaded", function() {
    const clickInModal = document.getElementById('clickInModal');
    if (!clickInModal) {
        console.warn('Click-in modal not found in the DOM');
        return;
    }

    const modalDismiss = document.getElementById('modalDismiss');
    const modalRegister = document.getElementById('modalRegister');
    
    function handleClickInVariant(radio) {
        if (radio.value.toLowerCase().includes('click')) {
            clickInModal.style.display = 'flex';
            radio.checked = false;
        }
    }

    const variantRadios = document.querySelectorAll('input[name="options[Select Connection Type]"]');
    variantRadios.forEach(radio => {
        radio.addEventListener('change', () => handleClickInVariant(radio));
    });

    if (modalDismiss) {
        modalDismiss.addEventListener('click', () => {
            clickInModal.style.display = 'none';
        });
    }

    if (modalRegister) {
        modalRegister.addEventListener('click', () => {
            window.location.href = 'https://www.burpi.com.au/pages/click-in-request';
        });
    }

    clickInModal.addEventListener('click', (e) => {
        if (e.target === clickInModal) {
            clickInModal.style.display = 'none';
        }
    });
});

// Product variant functionality for specific products
document.addEventListener('DOMContentLoaded', function() {
    console.log("UPDATED Product variant script loaded - " + new Date().toISOString());
    
    // Check if we're on one of our target product pages
    const productId = window.Product ? window.Product.id : null;
    if (!productId) {
        console.log("Product ID not found");
        return;
    }
    
    console.log("Current product ID:", productId);
    
    // Only apply to specific products
    if (productId !== 8841419948247 && productId !== 8847629025495) {
        console.log("Not a target product");
        return;
    }
    
    console.log("Target product detected:", productId);
    
    // Get the variant images - try multiple selectors to ensure we find them
    const variantImages = document.querySelectorAll('.variant-image');
    console.log("Variant images found:", variantImages.length);
    
    // If we don't find variant images with the class, try to find them by their position
    if (variantImages.length < 2) {
        console.log("Not enough variant images found by class, trying alternative approach");
        
        // Get all media items
        const mediaItems = document.querySelectorAll('.product__media-item');
        console.log("Media items found:", mediaItems.length);
        
        if (mediaItems.length >= 2) {
            // Manually set data attributes for the first and last media items
            const firstMedia = mediaItems[0];
            const lastMedia = mediaItems[mediaItems.length - 1];
            
            firstMedia.setAttribute('data-variant-id', 'screw-in');
            lastMedia.setAttribute('data-variant-id', 'click-in');
            
            // Hide all media items except the first one initially
            mediaItems.forEach((item, index) => {
                if (index === 0) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
            
            // Get the variant selectors
            const variantRadios = document.querySelectorAll('input[name="options[Select Connection Type]"]');
            if (!variantRadios.length) {
                console.log("No variant radios found");
                return;
            }
            
            console.log("Found variant radios:", variantRadios.length);
            
            // Get the click-in modal
            const clickInModal = document.getElementById('clickInModal');
            if (!clickInModal) {
                console.log("Click-in modal not found");
                return;
            }
            
            // Get the add to cart button
            const addToCartButton = document.querySelector('.product-form__submit');
            
            // Function to show the appropriate variant image
            function showVariantImage(variantId) {
                console.log("Showing variant image for:", variantId);
                
                if (variantId === 'screw-in') {
                    firstMedia.style.display = 'block';
                    lastMedia.style.display = 'none';
                } else if (variantId === 'click-in') {
                    firstMedia.style.display = 'none';
                    lastMedia.style.display = 'block';
                }
            }
            
            // Set up event listeners for variant radios
            variantRadios.forEach(radio => {
                // Remove existing event listeners by cloning and replacing
                const newRadio = radio.cloneNode(true);
                radio.parentNode.replaceChild(newRadio, radio);
            });
            
            // Get the fresh radios after replacement
            const freshRadios = document.querySelectorAll('input[name="options[Select Connection Type]"]');
            
            // Add event listeners to the fresh radios
            freshRadios.forEach(radio => {
                radio.addEventListener('change', function() {
                    const value = this.value.toLowerCase();
                    console.log("Radio changed:", value);
                    
                    if (value.includes('click')) {
                        // Show click-in modal
                        clickInModal.style.display = 'flex';
                        radio.checked = false;
                        
                        // Disable add to cart button
                        if (addToCartButton) {
                            addToCartButton.disabled = true;
                            addToCartButton.setAttribute('disabled', 'disabled');
                            addToCartButton.style.opacity = "0.5";
                            addToCartButton.style.pointerEvents = "none";
                        }
                        
                        // Show click-in image
                        showVariantImage('click-in');
                    } else if (value.includes('screw')) {
                        // Enable add to cart button
                        if (addToCartButton) {
                            addToCartButton.disabled = false;
                            addToCartButton.removeAttribute('disabled');
                            addToCartButton.style.opacity = "1";
                            addToCartButton.style.pointerEvents = "auto";
                        }
                        
                        // Show screw-in image
                        showVariantImage('screw-in');
                    }
                });
                
                // Check initial state
                if (radio.checked) {
                    const value = radio.value.toLowerCase();
                    console.log("Initially selected:", value);
                    
                    if (value.includes('click')) {
                        // Show click-in image
                        showVariantImage('click-in');
                    } else if (value.includes('screw')) {
                        // Show screw-in image
                        showVariantImage('screw-in');
                    }
                }
            });
            
            // Show default screw-in image on page load
            showVariantImage('screw-in');
            
            // Set up modal handlers
            const closeButton = document.querySelector('.close-button');
            const modalRegister = document.getElementById('modalRegister');
            
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    console.log("Modal closed via X button");
                    clickInModal.style.display = 'none';
                });
            }
            
            if (modalRegister) {
                modalRegister.addEventListener('click', () => {
                    console.log("Register interest clicked");
                    window.location.href = 'https://www.burpi.com.au/pages/click-in-request';
                });
            }
            
            clickInModal.addEventListener('click', (e) => {
                if (e.target === clickInModal) {
                    console.log("Modal background clicked");
                    clickInModal.style.display = 'none';
                }
            });
            
            // Add a class to the body to indicate that our handler is active
            document.body.classList.add('variant-handler-active');
        }
    } else {
        // Original code for when variant images are found by class
        // Get the variant selectors
        const variantRadios = document.querySelectorAll('input[name="options[Select Connection Type]"]');
        if (!variantRadios.length) {
            console.log("No variant radios found");
            return;
        }
        
        console.log("Found variant radios:", variantRadios.length);
        
        // Get the click-in modal
        const clickInModal = document.getElementById('clickInModal');
        if (!clickInModal) {
            console.log("Click-in modal not found");
            return;
        }
        
        // Get the add to cart button
        const addToCartButton = document.querySelector('.product-form__submit');
        
        // Function to show the appropriate variant image
        function showVariantImage(variantId) {
            console.log("Showing variant image for:", variantId);
            
            // Hide all variant images first
            variantImages.forEach(image => {
                image.style.display = 'none';
            });
            
            // Show the selected variant image
            const selectedImage = document.querySelector(`.variant-image[data-variant-id="${variantId}"]`);
            if (selectedImage) {
                console.log("Selected image found:", selectedImage.id);
                selectedImage.style.display = 'block';
            } else {
                console.log("No image found for variant:", variantId);
            }
        }
        
        // Set up event listeners for variant radios
        variantRadios.forEach(radio => {
            // Remove existing event listeners by cloning and replacing
            const newRadio = radio.cloneNode(true);
            radio.parentNode.replaceChild(newRadio, radio);
        });
        
        // Get the fresh radios after replacement
        const freshRadios = document.querySelectorAll('input[name="options[Select Connection Type]"]');
        
        // Add event listeners to the fresh radios
        freshRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                const value = this.value.toLowerCase();
                console.log("Radio changed:", value);
                
                if (value.includes('click')) {
                    // Show click-in modal
                    clickInModal.style.display = 'flex';
                    radio.checked = false;
                    
                    // Disable add to cart button
                    if (addToCartButton) {
                        addToCartButton.disabled = true;
                        addToCartButton.setAttribute('disabled', 'disabled');
                        addToCartButton.style.opacity = "0.5";
                        addToCartButton.style.pointerEvents = "none";
                    }
                    
                    // Show click-in image
                    showVariantImage('click-in');
                } else if (value.includes('screw')) {
                    // Enable add to cart button
                    if (addToCartButton) {
                        addToCartButton.disabled = false;
                        addToCartButton.removeAttribute('disabled');
                        addToCartButton.style.opacity = "1";
                        addToCartButton.style.pointerEvents = "auto";
                    }
                    
                    // Show screw-in image
                    showVariantImage('screw-in');
                }
            });
            
            // Check initial state
            if (radio.checked) {
                const value = radio.value.toLowerCase();
                console.log("Initially selected:", value);
                
                if (value.includes('click')) {
                    // Show click-in image
                    showVariantImage('click-in');
                } else if (value.includes('screw')) {
                    // Show screw-in image
                    showVariantImage('screw-in');
                }
            }
        });
        
        // Show default screw-in image on page load
        showVariantImage('screw-in');
        
        // Set up modal handlers
        const closeButton = document.querySelector('.close-button');
        const modalRegister = document.getElementById('modalRegister');
        
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                console.log("Modal closed via X button");
                clickInModal.style.display = 'none';
            });
        }
        
        if (modalRegister) {
            modalRegister.addEventListener('click', () => {
                console.log("Register interest clicked");
                window.location.href = 'https://www.burpi.com.au/pages/click-in-request';
            });
        }
        
        clickInModal.addEventListener('click', (e) => {
            if (e.target === clickInModal) {
                console.log("Modal background clicked");
                clickInModal.style.display = 'none';
            }
        });
        
        // Add a class to the body to indicate that our handler is active
        document.body.classList.add('variant-handler-active');
    }
});

// Add quantity-based price update functionality
document.addEventListener('DOMContentLoaded', function() {
    console.log("Quantity-based price update script loaded - " + new Date().toISOString());
    
    // Check if we're on one of our target product pages
    const productId = window.Product ? window.Product.id : null;
    if (!productId) {
        console.log("Product ID not found");
        return;
    }
    
    console.log("Current product ID for price update:", productId);
    
    // Only apply to specific products - 8841419948247 and 8847629025495
    if (productId !== 8841419948247 && productId !== 8847629025495) {
        console.log("Not a target product for price update");
        return;
    }
    
    console.log("Target product detected for price update:", productId);
    
    // Get the quantity input and price elements
    const quantityInput = document.querySelector('input[name="quantity"]');
    const priceElement = document.querySelector('.price__regular .price-item');
    const compareAtPriceElement = document.querySelector('.price__sale .price-item--regular');
    const salePriceElement = document.querySelector('.price__sale .price-item--sale');
    
    if (!quantityInput) {
        console.log("Quantity input not found");
        return;
    }
    
    if (!priceElement && !salePriceElement) {
        console.log("Price elements not found, trying alternative selectors");
        // Try alternative selectors
        const priceContainer = document.querySelector('.price');
        if (priceContainer) {
            const priceSpans = priceContainer.querySelectorAll('span.money, span.price-item');
            if (priceSpans.length > 0) {
                console.log("Found price spans:", priceSpans.length);
                updatePriceWithElements(priceSpans);
                return;
            }
        }
        console.log("Could not find any price elements");
        return;
    }
    
    // Get the base price from the product data
    const basePrice = window.Product.price / 100; // Convert from cents to dollars
    console.log("Base price:", basePrice);
    
    // Function to update the price based on quantity
    function updatePrice() {
        const quantity = parseInt(quantityInput.value);
        console.log("Quantity changed to:", quantity);
        
        if (isNaN(quantity) || quantity < 1) {
            return;
        }
        
        const totalPrice = basePrice * quantity;
        const formattedPrice = '$' + totalPrice.toFixed(2);
        console.log("Updated price:", formattedPrice);
        
        // Update the price display
        if (priceElement) {
            priceElement.textContent = formattedPrice;
        }
        
        // If there's a sale price, update that too
        if (salePriceElement) {
            salePriceElement.textContent = formattedPrice;
        }
        
        // If there's a compare-at price, update that too
        if (compareAtPriceElement && window.Product.compare_at_price) {
            const compareAtPrice = window.Product.compare_at_price / 100 * quantity;
            compareAtPriceElement.textContent = '$' + compareAtPrice.toFixed(2);
        }
    }
    
    // Alternative function for when we find price spans directly
    function updatePriceWithElements(priceSpans) {
        const basePrice = window.Product.price / 100;
        console.log("Base price for spans:", basePrice);
        
        function updatePriceSpans() {
            const quantity = parseInt(quantityInput.value);
            console.log("Quantity changed to (spans):", quantity);
            
            if (isNaN(quantity) || quantity < 1) {
                return;
            }
            
            const totalPrice = basePrice * quantity;
            const formattedPrice = '$' + totalPrice.toFixed(2);
            console.log("Updated price (spans):", formattedPrice);
            
            // Update all price spans
            priceSpans.forEach(span => {
                span.textContent = formattedPrice;
            });
        }
        
        // Update price on quantity change
        quantityInput.addEventListener('change', updatePriceSpans);
        quantityInput.addEventListener('input', updatePriceSpans);
        
        // Also attach to the quantity buttons
        const quantityButtons = document.querySelectorAll('.quantity__button');
        if (quantityButtons.length) {
            quantityButtons.forEach(button => {
                button.addEventListener('click', function() {
                    // Use setTimeout to allow the quantity to update first
                    setTimeout(updatePriceSpans, 10);
                });
            });
        }
        
        // Initial price update
        updatePriceSpans();
    }
    
    // Update price on quantity change
    quantityInput.addEventListener('change', updatePrice);
    quantityInput.addEventListener('input', updatePrice);
    
    // Also attach to the quantity buttons
    const quantityButtons = document.querySelectorAll('.quantity__button');
    if (quantityButtons.length) {
        quantityButtons.forEach(button => {
            button.addEventListener('click', function() {
                // Use setTimeout to allow the quantity to update first
                setTimeout(updatePrice, 10);
            });
        });
    }
    
    // Initial price update
    updatePrice();
});